class PLPPagination extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.hasNext = true;
      this.page = 1;
      this.observer = null;
      this.abortController = null;
      this.handleExternalReset = this.handleExternalReset.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
    }
  
    connectedCallback() {
      this.cacheDom();
      if (!this.grid || !this.loader) return;
      this.sectionId = this.getAttribute('section-id');
      this.reset();
      this.initObserver();
      document.addEventListener('plp:filters:updated', this.handleExternalReset);
    }
  
    disconnectedCallback() {
      document.removeEventListener('plp:filters:updated', this.handleExternalReset);
      this.cleanup();
    }
  
    cacheDom() {
      this.grid = this.querySelector('#products-grid');
      this.loader = this.querySelector('[data-plp-pagination-loader]');
    }
  
    reset(page = Number(this.getAttribute('current-page')) || 1) {
      const url = new URL(window.location.href);
      this.page = page;
      this.hasNext = true;
      this.loading = false;
      this.basePath = url.pathname;
      this.searchParams = new URLSearchParams(url.searchParams);
      this.searchParams.delete('page');
      this.loader.hidden = false;
    }
  
    handleExternalReset() {
      this.abortController?.abort();
      this.abortController = null;
      this.cleanup();
      this.cacheDom();
      if (!this.grid || !this.loader) return;
      if (this.grid.hasAttribute('data-empty')) {
        this.hasNext = false;
        this.loader.hidden = true;
        return;
      }
      this.reset(1);
      this.initObserver();
    }
  
    initObserver() {
      if (this.observer) return;
      this.observer = new IntersectionObserver(this.onIntersect, {
        rootMargin: '400px',
      });
      this.observer.observe(this.loader);
    }
  
    onIntersect(entries) {
      if (!entries.length || !entries[0].isIntersecting) return;
      this.loadNext();
    }
  
    cleanup() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }
  
    async loadNext() {
      if (this.loading || !this.hasNext) return;
      this.loading = true;
      this.observer?.unobserve(this.loader);
      this.abortController = new AbortController();
      const params = new URLSearchParams(this.searchParams);
      params.set('page', this.page + 1);
      params.set('section_id', this.sectionId);
      const url = `${this.basePath}?${params}`;

      try {
        const res = await fetch(url, { signal: this.abortController.signal });
        if (!res.ok) throw new Error('Pagination fetch failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('#products-grid');
        if (!newGrid || !newGrid.children.length) {
          this.hasNext = false;
          this.loader.hidden = true;
          return;
        }

        this.grid.append(...newGrid.children);
        this.page += 1;
      } catch (e) {
        if (e.name === 'AbortError') return;
        console.error(e);
      } finally {
        this.loading = false;
        if (this.hasNext) this.observer?.observe(this.loader);
      }
    }
  }
  
  customElements.define('plp-pagination', PLPPagination);